import React from 'react';

import logoLight from 'assets/images/CorporateLanding/logo-footer.svg';

export default function Footer() {
  return (
    <footer className="subfooter">
      <div className="container">
        <div className="subfooter-row">
          <div className="subfooter-logo">
            <strong className="logo">
              <a href="#top">
                <img src={logoLight} alt="logo" />
              </a>
            </strong>
          </div>
          <div className="subfooter-text size-xs">
            <h3 className="subfooter-title">
              myBasePay can gauge your liability exposure and advise on steps to
              avoid <br /> co-employment. Call us for a no-cost consultation.
            </h3>
          </div>
        </div>
      </div>
    </footer>
  );
}
